import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  ShowModal() {
    $('#warningModal').modal('show');
  }

}
